import * as React from 'react'

import { styled } from '~/styled'

import { ToastCloseButton } from './ToastCloseButton'
import { useToastContext } from './ToastContext'
import { ToastIcon } from './ToastIcon'

export const StyledToast = styled('div', {
  base: [
    'flex',
    'items-center',
    'pointer-events-auto',
    'rounded-md',
    'shadow-md',
    'box-border',
    'text-white',
    'min-h-12',
    'relative',
    'px-4',
    'py-1',
    'motion-safe:duration-125',
    'motion-safe:ease-out',
    'motion-safe:transition-[colors,transform]'
  ],
  variants: {
    type: {
      loading: ['bg-info'],
      blank: ['bg-info'],
      success: ['bg-success'],
      error: ['bg-danger']
    }
  }
})

export const Toast = (props: React.ComponentProps<typeof StyledToast>) => {
  const { type } = useToastContext()
  const styledType = type === 'custom' ? undefined : type
  return <StyledToast type={props.type || styledType} {...props} />
}

Toast.Icon = ToastIcon
Toast.Close = ToastCloseButton
